import React from 'react';
import Footer from './../Components/Navbar/Footer';
import { list } from 'postcss';

/**
 * Lenox Paints - Privacy Policy (Single Page)
 *
 * A responsive React component displaying placeholder privacy policy text.
 * Styled with the specified colors: #ed3237 (primary red) and black.
 *
 * IMPORTANT: This is placeholder text. Replace it with the official policy
 * from the Lenox Paints website footer.
 */
const PrivacyPolicy = () => {
  // Styles object using the specified color palette
  const styles = {
    container: {
      maxWidth: '1200px', // Slightly narrower for a single column
      margin: '0 auto',
      padding: '20px',
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, sans-serif',
      lineHeight: 1.6,
      color: '#000000',
      backgroundColor: '#ffffff',
    },
    header: {
      textAlign: 'center',
      marginBottom: '40px',
      padding: '20px 10px',
      borderBottom: `4px solid #ed3237`,
    },
    headerTitle: {
      fontSize: 'clamp(2rem, 5vw, 2.8rem)',
      fontWeight: '700',
      marginBottom: '10px',
      color: '#000000',
    },
    headerSubtitle: {
      fontSize: 'clamp(1rem, 3vw, 1.2rem)',
      color: '#333333',
      fontWeight: '300',
    },
    lastUpdated: {
      display: 'inline-block',
      margin: '15px 0',
      padding: '6px 16px',
      backgroundColor: '#f5f5f5',
      borderRadius: '30px',
    
      color: '#000000',
      border: '1px solid #e0e0e0',
    },
    policyCard: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '30px',
      boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)',
      border: '1px solid #eaeaea',
      marginBottom: '30px',
    },
    cardTitle: {
     
      fontWeight: '600',
      marginBottom: '25px',
      paddingBottom: '12px',
      borderBottom: `3px solid #ed3237`,
      color: '#000000',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    sectionTitle: {
    
      fontWeight: '600',
      marginTop: '30px',
      marginBottom: '15px',
      color: '#000000',
    },
    text: {
      marginBottom: '18px',
      color: '#222222',
    },
    list: {
      margin: '10px 0 25px 25px',
      color: '#222222',
    },
    listItem: {
      marginBottom: '10px',
      listStyleType: 'disc',
      fontSize: '16px',
    },
    footnote: {
      marginTop: '30px',
      padding: '25px',
      backgroundColor: '#f8f8f8',
      borderRadius: '10px',
      textAlign: 'center',
      color: '#333333',
      borderLeft: `4px solid #ed3237`,
    },
    link: {
      color: '#ed3237',
      textDecoration: 'none',
      fontWeight: '500',
      borderBottom: '1px dotted #ed3237',
    },
    badge: {
      display: 'inline-block',
      padding: '4px 12px',
      backgroundColor: '#ed3237',
      color: '#ffffff',
      borderRadius: '20px',
      fontSize: '0.75rem',
      fontWeight: '600',
      letterSpacing: '0.5px',
      marginLeft: '10px',
    },
  };

  return (
    <div>
    <div style={styles.container}>
      {/* Main Privacy Policy Content */}
      <div style={styles.policyCard}>
        <h2 style={styles.cardTitle}>
       
          Our Commitment to Privacy
        </h2>
         <div style={styles.lastUpdated}>Last Updated: 09 March 2026</div>

        <p style={styles.text}>
          At Lenox Paints, we are committed to protecting your privacy. This
          policy explains how we collect, use, and safeguard your personal
          information when you visit our website or interact with our services.
        </p>

        <h3 style={styles.sectionTitle}>Information We Collect</h3>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            <strong>Personal Information:</strong> Name, email, phone number
            (collected via enquiry forms).
          </li>
          <li style={styles.listItem}>
            <strong>Usage Data:</strong> Pages visited, time spent, browser
            type (via cookies).
          </li>
          <li style={styles.listItem}>
            <strong>Project Preferences:</strong> Paint finishes, colour
            interests (if shared).
          </li>
        </ul>

        <h3 style={styles.sectionTitle}> How We Use Your Data</h3>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            Respond to dealer and customer enquiries.
          </li>
          <li style={styles.listItem}>
            Improve website experience and product offerings.
          </li>
          <li style={styles.listItem}>
            Send updates about new products (only with consent).
          </li>
        </ul>

        <h3 style={styles.sectionTitle}> Data Sharing & Security</h3>
        <p style={styles.text}>
          We <strong>never sell</strong> your personal data. Information may be
          shared with trusted partners solely for order fulfilment or analytics
          under strict confidentiality agreements. We use industry-standard SSL
          encryption to protect your data.
        </p>

        <h3 style={styles.sectionTitle}> Cookies</h3>
        <p style={styles.text}>
          Essential cookies are used to maintain session security. By using our
          website, you consent to our use of cookies. You can manage
          preferences through your browser settings.
        </p>

        <h3 style={styles.sectionTitle}>Contact Us</h3>
        <p style={styles.text}>
          For privacy-related concerns:{' '}
          <strong>info@lenoxpaints.com</strong> or write to our registered
         <br />
            #785, Ground Floor, 16th Main Road
            <br />
            23rd 'A' Cross, Near HSR Club
            <br />
            HSR Layout, 3rd Sector
            <br />
            Bangalore - 560102.
        </p>
      </div>

    
    </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;